import { API_CONFIG, buildApiUrl } from "../config/api";
import { ApiResponse } from "../types";
import {
    VipMember,
    CreateVipDto,
    UpdateVipDto,
    VipQueryParams,
    VipListResponse,
    VipEnumsResponse,
    UserVipInfo,
} from "../types/vip";
import { http, buildUrl } from "./base";

/**
 * VIP 会员管理相关 API 服务
 */
export class VipService {
    /**
     * 创建 VIP 会员
     * @param data VIP 会员数据
     */
    static async createVip(data: CreateVipDto): Promise<ApiResponse<VipMember>> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.VIP.CREATE);
        return http.post(url, data);
    }

    /**
     * 获取 VIP 会员列表
     * @param params 查询参数
     */
    static async getVipList(
        params?: VipQueryParams
    ): Promise<ApiResponse<VipListResponse>> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.VIP.LIST);
        return http.get(url, params);
    }

    /**
     * 获取 VIP 相关枚举值
     */
    static async getVipEnums(): Promise<ApiResponse<VipEnumsResponse>> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.VIP.ENUMS);
        return http.get(url);
    }

    /**
     * 更新 VIP 会员信息
     * @param id VIP 会员ID
     * @param data 更新数据
     */
    static async updateVip(
        id: number,
        data: UpdateVipDto
    ): Promise<ApiResponse<VipMember>> {
        const url = buildApiUrl(API_CONFIG.ENDPOINTS.VIP.UPDATE, {
            id: id.toString(),
        });
        return http.patch(url, data);
    }

    /**
     * 获取用户的 VIP 信息
     * @param accountId 用户ID
     */
    static async getUserVipInfo(
        accountId: number
    ): Promise<ApiResponse<UserVipInfo>> {
        const url = buildApiUrl(API_CONFIG.ENDPOINTS.VIP.ACCOUNT_INFO, {
            accountId: accountId.toString(),
        });
        return http.get(url);
    }
}

export default VipService;

